import React from 'react';

interface AuthErrorMessageProps {
  error?: string | null;
}

const AuthErrorMessage: React.FC<AuthErrorMessageProps> = ({ error }) => {
  if (!error) return null;
  if (error === 'User already exists') {
    error = 'Email already exists.';
  }
  return <div className="mb-2 text-sm text-red-500">&#9888; {error}</div>;
};

export default AuthErrorMessage;
